import { Flex, Skeleton, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getActivity, getCurrentEmi } from 'shared/config/store/selectors/app';
import { RootState } from 'shared/config/store/store';
import { getEMIMonthSpend } from 'shared/config/store/reducers/accountsSlice';
import classes from '../ui/Transactions.module.scss';
import { useGetMonthSpendQuery } from '../api';

export const MonthSpending = ({ accountId, start }: { accountId: number, start: string }) => {
  const { formatMessage: t } = useIntl();
  useGetMonthSpendQuery({ accountId, start });
  const currentEmi = useSelector(getCurrentEmi);
  const monthSpend = useSelector((state: RootState) => getEMIMonthSpend(state, currentEmi));
  const currentMonthSpend = monthSpend?.[String(accountId)] || 0;
  const activity = useSelector(getActivity);

  return (
    <Flex justify='space-between'>
      <Typography.Text className={classes.text}>
        {t(
          { id: 'transactions.spent' },
          { month: t({ id: `calendar.month.${new Date().getMonth()}` }) }
        )}
      </Typography.Text>
      <Skeleton active loading={activity} paragraph={{ rows: 1 }}>
        <Typography.Text className={classes.balance}>
          {(currentMonthSpend)?.toFixed(2)} €
        </Typography.Text>
      </Skeleton>
    </Flex>
  );
};
